import { forwardRef, type Ref, type SVGProps } from "react";

function SvgUserRemove(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19.5 11.5h-2.75m2.75 0h2.75m-7.5-5a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0M3.981 18.113c1.053-2.849 3.626-4.863 7.017-4.863s5.964 2.014 7.018 4.863c.409 1.105-.536 2.137-1.715 2.137H5.696c-1.179 0-2.123-1.032-1.714-2.137"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgUserRemove);
export default ForwardRef;
